<script>
  import In from "@/components/atoms/In";
  import Btn from "@/components/atoms/Btn";
  import Banner from "@/components/atoms/Banner";
  import SaveFile from "@/components/atoms/SaveFile";
  import Loading from "@/components/atoms/Loading";
  import PartRow from "@/components/atoms/PartRow";
  import { StripeCheckout } from '@vue-stripe/vue-stripe';

  export default {
    components: { In, Btn, Banner, SaveFile, Loading, PartRow, StripeCheckout },
    mounted(){
      if(this.order){
        this.$store.dispatch('payment/startCheckoutSession').then(clientSecret => {
          // console.log(clientSecret)
          this.elements = this.stripe.elements({ 
            clientSecret,
            appearance: {
              theme: 'night',
              labels: 'floating',
              variables: {
                colorPrimary: '#b263f7',
                colorTextPlaceholder: '#AAA',
                // colorTextSecondary: '#FFF',
                colorBackground: '#525252',
                // colorText: '#30313d',
                // colorDanger: '#df1b41',
                fontFamily: 'Montserrat, sans-serif',
                // spacingUnit: '2px',
                // borderRadius: '4px',
                // border: "1px solid #737373"
              },
              rules: {
                '.Input': {
                  border: '2px solid #737373',
                  boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
                },
              }
            }
          });

          this.addressElement = this.elements.create("address", {
            mode: "shipping",
            allowedCountries: ['US'],
            fields: {
              phone: 'always',
            },
            validation: {
              phone: {
                required: 'always',
              },
            },
            autocomplete: {
              mode: "google_maps_api",
              apiKey: "AIzaSyAEXALT6XZ_f0ZN1ri_mKGl8ATtuFJxMk8",
            },
          });
          this.addressElement.mount(this.$refs.address);
          this.addressElement.on('change', (event) => {
            this.address = event.value.address;
            this.name = event.value.name;
            this.phone = event.value.phone;
          })
          this.addressElement.on('focus', (event) => {
            this.$store.dispatch('postMessage', "keyboard:keyboard");
          })
          this.addressElement.on('blur', (event) => {
            this.$store.dispatch('postMessage', "keyboard:null");
          })

          this.paymentElement = this.elements.create('payment');
          this.paymentElement.mount(this.$refs.card);
          this.paymentElement.on('focus', (event) => {
            this.$store.dispatch('postMessage', "keyboard:keyboard");
          })
          this.paymentElement.on('blur', (event) => {
            this.$store.dispatch('postMessage', "keyboard:null");
          })
        }).catch(error => {
          console.error({
            projectId: this.order.projectId,
            location: "payment/startCheckoutSession",
            error
          })
        })
      }else{
        this.$router.push('/Cart')
      }
    },  
    data(){
      return {
        address: null,
        name: null,
        phone: null,
        cardError: null,
        shippingError: null,
        step: "shipping",
        elements: null,
        addressElement: null,
        paymentElement: null,
        shippingLoading: false,
        paymentLoading: false,
      }
    },
    computed: {
      order(){
        return this.$store.get('payment/pendingOrder')
      },
    },
    methods: {
      getShipping(){
        this.mixpanel.track('Shipping Requested', {
          projectId: this.order.projectId,
        });
        this.shippingLoading = true;
        this.shippingError = null;
        this.$store.dispatch("payment/addShippingToOrder", {
          ...this.order,
          shippingAddress: this.address,
          name: this.name,
          phone: this.phone,
        }).then(order => {
          // console.log(order);
          this.$store.dispatch('payment/pendingOrder', order);
          this.step = 'pay';
          this.shippingLoading = false;
          this.mixpanel.track('Shipping Added', {
            projectId: this.order.projectId,
          });
        }).catch(e => {
          console.error({
            projectId: this.order.projectId,
            location: "getShipping",
            error: e
          });
          this.shippingError = e;
          this.shippingLoading = false;
        })
      },
      placeOrder(){
        this.mixpanel.track('Place Order Requested', {
          projectId: this.order.projectId
        });
        this.paymentLoading = true;
        this.cardError = null;
        this.stripe.confirmSetup({
          elements: this.elements,
          confirmParams: {
            // Return URL where the customer should be redirected after the SetupIntent is confirmed.
            return_url: "https://quadrobee.web.app/#/order",
          },
          redirect: "if_required"
        })
        .then(result => {
          const errorCodes = [
            "incomplete_name",
            "incomplete_address",
            "empty_phone_number",
          ]
          if(result.error){
            this.paymentLoading = false;
            if(errorCodes.includes(result.error.code)){
              this.step = 'shipping';
            }
            this.cardError = result.error.message;  
            this.mixpanel.track('Card Error', {
              projectId: this.order.projectId,
              location: "payment/chargeCard",
              error: result.error.message
            });
          }else{
            this.$store.dispatch("payment/chargeCard", {
              ...this.order,
              paymentMethodId: result.setupIntent.payment_method
            }).then(order => {
              this.paymentLoading = false;
              if(order.confirmation){
                this.$store.dispatch('payment/pendingOrder', order);
                this.mixpanel.track('Place Order Confirmed', {
                  projectId: this.order.projectId,
                });
                this.$store.dispatch("payment/sendConfirmation", order)
                this.$router.push({name: 'OrderConfirmation'})
              }else{
                console.error({
                  projectId: this.order.projectId,
                  location: "payment/chargeCard",
                  error: "Did not get an order confirmation number."
                })
              }
            }).catch(response => {
              // console.log(response);
              this.paymentLoading = false;
              if(response && response.status){
                console.error({
                  projectId: this.order.projectId,
                  location: "payment/chargeCard",
                  error: response.status
                })
              }else{
                console.error({
                  projectId: this.order.projectId,
                  location: "payment/chargeCard",
                  error: response
                })
              }
            })
          }
        }).catch(e => {
          console.error({
            location: "placeOrder",
            projectId: this.order.projectId,
            error: e
          })
          this.paymentLoading = false;
          this.cardError = e;
        });
      }
    }
  }
</script>

<template>
  <Banner>
    <div id="order-page" :class="{'mobile': $store.get('usingMobile')}">
      <div class="payment-limiter">
        <div class="payment">
          <btn class="back-button" size="large" color="secondary" @click="$router.go(-1)"><i class="fas fa-caret-left"></i> Back</btn>
          <div class="modal" v-show="step == 'shipping'" >
            <div class="modal-title">
              Shipping
            </div>
            <div class="card">
              <div ref="address" class="shipping-address">Loading...</div>
            </div>
            <btn class="next" type="fill" stretch="full" :loading="shippingLoading" @click="() => getShipping()">Next</btn>
            <div class="card-errors" ref="shipping-errors" role="alert" v-if="shippingError">
              {{shippingError}}
              Please email Support@Quadrobee.com
            </div>
          </div>
          <div class="modal fixed" :class="{hide: step != 'pay'}">
            <div class="modal-title">
              Shipping
            </div>
            <div class="card fixed-card">
              <div class="left">
                <div class="name">
                  {{name ? name : "--"}}
                </div>
                <div class="address">
                  <span v-if="address">
                    {{address.line1}}{{address.line2 ? " "+address.line2 : ""}}, {{address.city}} {{address.state}} {{address.postal_code}}, {{address.country}}
                  </span>
                  <span v-else>
                    --
                  </span>
                </div>
                <div class="phone">
                  {{phone ? phone : "--"}}
                </div>
              </div>
              <div class="right">
                <div class="edit-button" @click="step = 'shipping'">
                  edit
                </div>
              </div>
            </div>
          </div>
          <div class="modal" key="pay" :class="{hide: step != 'pay'}">
            <div class="modal-title">
              Payment
            </div>
            <div class="card" key="pay-card">
              <div ref="card"></div>
            </div>
          </div> 
        </div>
      </div>
      <div class="summary-limiter">
        <div class="summary">
          <div class="image-col" v-if="this.order.imageUrl">
            <img class="image" :src="this.order.imageUrl" />
          </div>
          <div class="summary-title">
            Order Summary
          </div>
          <div class="line">
            <div class="title">Items</div>
            <div class="value">{{this.order && this.order.itemCount ? this.order.itemCount : '--'}}</div>
          </div>
          <div class="line">
            <div class="title">Subtotal</div>
            <div class="value">${{this.order && this.order.preShippingTotal ? this.order.preShippingTotal : '--'}}</div>
          </div>
          <div class="line">
            <div class="title">Shipping</div>
            <div class="value">${{this.order && this.order.shippingTotal ? this.order.shippingTotal : '--'}}</div>
          </div>
          <div class="shipping-estimate" v-if="this.order && this.order.shippingTotal">
            Estimated Delivery: 2-3 weeks
          </div>
          <div class="line total">
            <div class="title">Total</div>
            <div class="value"><span class="small">USD</span>${{this.order ? (this.order.total ? this.order.total : this.order.preShippingTotal) : '--'}}</div>
          </div>
          <btn v-show="step == 'pay'" class="place-order" type="fill" stretch="full" :loading="paymentLoading" @click="() => placeOrder()">Place Order</btn>
          <div class="card-errors" ref="card-errors" role="alert">
            {{cardError}}
          </div>
        </div>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#order-page{
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex: 1;
  flex-wrap: wrap;
  &.mobile{
    .payment-limiter{
      .payment{
        flex-basis: 100%;
        padding: 0rem 1.5rem 1.5rem 1.5rem;
      }
    }
    .summary-limiter{
      flex-basis: 100%;
    }
  }
  .card-errors{
    margin-top: 1rem;
    color: $r;
  }
  .payment-limiter{
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    .payment{
      flex-basis: 45rem;
      padding: 0rem 4rem 4rem 4rem;
      .back-button{
        margin-bottom: 0.5rem;
        margin-left: -1.5rem;
      }
      .modal{
        &.hide{
          opacity: 0;
          pointer-events: none;
        }
      }
      .modal-title{
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }
      .shipping-address{
        
      }
      .fixed{
        margin-bottom: 2rem;
        .fixed-card{
          padding: 2rem 1rem 2rem 2rem;
          position: relative;
          display: flex;
          .left{
            flex: 1;
            .name{
              font-size: 1.5rem;
              margin-bottom: 0.5rem;
            }
            .address{
              font-size: 1.125rem;
              margin-bottom: 0.5rem;
            }
            .phone{
              font-size: 1.125rem;
            }
          }
          .right{
            width: 6rem;
            .edit-button{
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: $w_1;
              &:hover, &.hover{
                color: $w;
                cursor: pointer;
              }
            }
          }
        }
      }
      
      .card{
        background-color: $black_2;
        box-shadow: $z_depth_2;
        padding: 2rem;
        border-radius: 0.25rem;
        margin-bottom: 2rem;
      }
    }
  }
  .summary-limiter{
    flex-basis: 45%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    // border-left: 2px solid $black_3;
    background-color: $black_2;
    .image-col{
      width: 60%;
      margin-bottom: 2rem;
      border: 2px solid $black_3;
      border-radius: 6px;
      img{
        width: 100%;
        filter: brightness(2.5);
      }
    }
    .summary{
      flex-basis: 36rem;
      padding: 4rem;
      .summary-title{
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }
      .line{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1.5rem;
        font-size: 1.125rem;
        &.total{
          font-size: 1.5rem;
          border-top: 2px solid $black_3;
          padding-top: 1rem;
          margin-top: 1.5rem;
          .title{
          }
          .value{
            font-size: 1.75rem;
            .small{
              font-size: 1rem;
              margin-right: 0.5rem;
            }
          }
        } 
        .title{
        }
        .value{
          font-size: 1.25rem;
        }
      }
      .shipping-estimate{
        margin-top: 0.5rem;
      }
      .place-order{
        margin-top: 1rem;
      }
    }
  }
}
</style>